import { Component, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AlphaSharedModule } from '../../../shared/alpha-shared.module';

@Component({
    selector: 'app-delete-custom-list',
    standalone: true,
    imports: [AlphaSharedModule],
    templateUrl: './delete-custom-list.component.html',
    styles: ``,
})
export class DeleteCustomListComponent {
    private dynamicDialogRef = inject(DynamicDialogRef);
    private dynamicDialogConfig = inject(DynamicDialogConfig);
    title: string = 'Confirm deletion';
    itemName: string = '';
    constructor() {
        this.title = this.dynamicDialogConfig.data.title || this.title;
        this.itemName = this.dynamicDialogConfig.data.itemName || this.itemName;
    }

    onClose(data: boolean) {
        this.dynamicDialogRef.close(data);
    }
}
